<template>
    <footer class="bg-accent py-5">
        <div class="container flex flex-col md:flex-row gap-8 my-8">
            <div class="md:w-2/5 lg:w-lg text-white">
                <img
                    :src="cdnUrl + '/assets/images/trusted-parts-logo.svg'"
                    alt="TrustedParts.com"
                    class="mb-4"
                    loading="lazy"
                    width="275"
                    height="40" />
                <div class="text-lg" v-html="$t('Layout.MissionStatement_Subtitle')"></div>
                <p class="mt-4" v-html="$t('Layout.MissionStatement_Paragraph1')"></p>
                <p v-html="$t('Layout.MissionStatement_Paragraph2')"></p>
                <p v-html="$t('Layout.MissionStatement_Paragraph3')"></p>
                <p v-html="$t('Layout.MissionStatement_LinkText')"></p>
            </div>
            <div class="md:w-2/5 lg:w-md lg:ml-auto">
                <FooterSearchBox />
                <NuxtLinkLocale
                    id="lnkFooterBulkSearch"
                    class="inline-block my-8 text-xl font-bold text-accent-secondary hover:text-accent-secondary hover:no-underline"
                    to="/bom/import"
                    :title="$t('Layout.BulkSearchLinkText')">
                    {{ $t("Layout.BulkSearchLinkText") }}
                </NuxtLinkLocale>

                <div class="grid grid-cols-2 gap-8">
                    <div class="space-y-4">
                        <NuxtLinkLocale
                            v-for="link in leftLinks"
                            :id="link.id"
                            :key="link.id"
                            :to="link.to"
                            :title="$t(link.labelKey)"
                            class="block text-white hover:text-white">
                            {{ $t(link.labelKey) }}
                        </NuxtLinkLocale>
                        <a
                            href="http://www.ecianow.org/"
                            target="_blank"
                            rel="noopener"
                            title="ecianow.org"
                            class="block text-white hover:text-white">
                            ecianow.org
                        </a>
                        <div class="flex flex-row gap-6">
                            <a
                                href="https://www.linkedin.com/company/trustedparts-com/"
                                target="_blank"
                                rel="noopener"
                                title="LinkedIn">
                                <img src="~/assets/icons/linkedin-logo.svg" class="h-6" alt="LinkedIn" />
                            </a>
                            <a
                                href="https://www.youtube.com/@trustedparts6152"
                                target="_blank"
                                rel="noopener"
                                title="Youtube">
                                <img src="~/assets/icons/youtube-logo.svg" class="h-6 fill-white" alt="Youtube" />
                            </a>
                        </div>
                    </div>
                    <div class="space-y-4">
                        <NuxtLinkLocale
                            v-for="link in rightLinks"
                            :id="link.id"
                            :key="link.id"
                            :to="link.to"
                            :title="$t(link.labelKey)"
                            class="block text-white hover:text-white">
                            {{ $t(link.labelKey) }}
                        </NuxtLinkLocale>
                    </div>
                </div>
            </div>

            <div class="my-4 footerIPTheftLogo">
                <a href="http://www.iprcenter.gov/disclaimer/" :title="$t('Layout.IPTheftLogoTitle')" rel="noopener">
                    <img
                        :src="cdnUrl + '/assets/images/reportiptheftbutton.png'"
                        :alt="$t('Layout.IPTheftLogoTitle')"
                        width="80"
                        height="80"
                        loading="lazy" />
                </a>
            </div>
        </div>
        <div class="mt-5 text-center text-white">©{{ currentYear }} Electronic Components Industry Association</div>
    </footer>
</template>
<script setup lang="ts">
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
const currentYear = new Date().getFullYear();

type FooterLink = { id: string; to: string; labelKey: string };

const leftLinks: FooterLink[] = [
    { id: "lnkFooterAboutUs", to: "/about-us", labelKey: "Layout.LinkAbout" },
    { id: "lnkFooterBlog", to: "/blog", labelKey: "Layout.LinkBlog" },
    { id: "lnkFooterContact", to: "/contact-us", labelKey: "Layout.LinkContact" },
    { id: "lnkFooterDocumentation", to: "/docs", labelKey: "Layout.LinkDocumentation" },
];

const rightLinks: FooterLink[] = [
    { id: "lnkInsights", to: "/authorized-channel-insights", labelKey: "Layout.LinkInsights" },
    { id: "lnkManufacturers", to: "/manufacturers", labelKey: "Layout.LinkManufacturers" },
    { id: "lnkPrivacyPolicy", to: "/privacy-policy", labelKey: "Layout.LinkPrivacyPolicy" },
    { id: "lnkFooterSiteMap", to: "/sitemap", labelKey: "Layout.LinkSitemap" },
    { id: "lnkTermsAndConditions", to: "/terms-and-conditions", labelKey: "Layout.LinkTerms" },
];
</script>
